<template>
    <img alt="etisia logo" src="/assets/images/logo.png" class="!h-7">
</template>

<script setup>
</script>